import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AUTH_LOCAL_STORAGE_KEY } from '../../constants'
import { UserModel } from '../../models'
export interface AuthState {
    apiToken: string,
    currentUser: UserModel | undefined
}

const initialState: AuthState = {
    apiToken: (localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) || '').toString(),
    currentUser: undefined
}

export const AuthSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setApiToken: (state, action: PayloadAction<string>) => {
            state.apiToken = action.payload
            localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, action.payload)
        },
        setCurrentUser: (state, action: PayloadAction<UserModel>) => {
            state.currentUser = action.payload
        },
        removeApiToken: (state) => {
            state.apiToken = '';
            localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
            state.currentUser = undefined
        }
    }
})

export const { setApiToken, setCurrentUser, removeApiToken } = AuthSlice.actions

export default AuthSlice.reducer
